// Approximate length of 1° of latitude in meters (Earth circumference / 360)
const METERS_PER_LAT_DEG = 111320;

// Earth circumference at the equator
const EARTH_CIRCUMFERENCE_IN_METERS = 40075016.686;

export { EARTH_CIRCUMFERENCE_IN_METERS, METERS_PER_LAT_DEG };
